import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-multi-patient-note',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './multi-patient-note.component.html',
  styleUrls: ['./multi-patient-note.component.scss']
})
export class MultiPatientNoteComponent {

  @Input() theme;

  constructor(public vars: VariablesService) {}

}
